import React from "react";
import { Helmet } from "react-helmet-async";

import Navbar from "../components/Navbar";
import SecondaryHero from "../components/SecondaryHero";
import JobsSection from "../components/JobSection";
import Footer from "../components/Footer";

const ApplyForJob = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Jobs | VisionBird</title>
        <meta
          name="description"
          content="Apply for jobs or internships at VisionBird Technologies. Join our team and grow your career in web development, design, and technology."
        />
        <meta
          name="keywords"
          content="VisionBird jobs, apply for job, internships Pakistan, web developer jobs, software house careers"
        />
      </Helmet>

      <Navbar />

      <SecondaryHero
        title="Searching for a"
        titleLast="?"
        highlight="job"
        description="We value individuals who bring a constructive and innovative 
        mindset to their work. Whether you're seeking a permanent position 
        or an internship, just fill out the form below and hit 'Send.' We'll review 
        your application, and if you meet our criteria, we’ll get in touch to 
        schedule an interview."
        image="/assets/Images/Resume-pana 1.png"
      />

      <JobsSection />

      <Footer />
    </>
  );
};

export default ApplyForJob;